export class AppRoute {

    // Public routes
    static HOME_ROUTE = '/';
    static LOGIN_ROUTE = '/login';
    static REGISTER_ROUTE = '/register';
    static MENU_ROUTE = (slug: string) => `/${slug}`;
    static MENU_ABOUT_ROUTE = (slug: string) => `/${slug}/about`;
    
    // Error routes
    static ACCESS_DENIED_ROUTE = '/access-denied';

    // Business Owner routes
    static BUSINESS_OWNER_DASHBOARD_ROUTE = '/dashboard';
    static BUSINESS_OWNER_BUSINESSES_ROUTE = '/businesses';
    static BUSINESS_OWNER_MENU_ROUTE = '/menu';
    static BUSINESS_OWNER_ORDERS_ROUTE = '/orders';
    static BUSINESS_OWNER_CAMPAIGNS_ROUTE = '/campaigns';
    static BUSINESS_OWNER_ANALYTICS_ROUTE = '/analytics';
    static BUSINESS_OWNER_USERS_ROUTE = '/users';
    static BUSINESS_OWNER_SETTINGS_ROUTE = '/settings';

    // Business Cashier routes
    static BUSINESS_CASHIER_DASHBOARD_ROUTE = '/cashier/dashboard';
    static BUSINESS_CASHIER_MENU_ROUTE = '/cashier/menu';
    static BUSINESS_CASHIER_SETTINGS_ROUTE = '/cashier/settings';

    // Business Employee routes
    static BUSINESS_EMPLOYEE_DASHBOARD_ROUTE = '/employee/dashboard';
    static BUSINESS_EMPLOYEE_MENU_ROUTE = '/employee/menu';
    static BUSINESS_EMPLOYEE_SETTINGS_ROUTE = '/employee/settings';

    // System Admin routes
    static SYSTEM_ADMIN_DASHBOARD_ROUTE = '/admin/dashboard';
    static SYSTEM_ADMIN_SETTINGS_ROUTE = '/admin/settings';

    // Monitor routes
    static MONITOR_DASHBOARD_ROUTE = '/monitor/dashboard';
    static MONITOR_SETTINGS_ROUTE = '/monitor/settings';

}